/**
 * switch-popup-group.js — make a whole GROUP open the popup-link it wraps.
 *
 * Horizon's `popup-link` block (blocks/popup-link.liquid) only opens on its own
 * `.popup-link__button` (the heading text, width: fit-content). When the popup
 * sits in a group alongside other blocks (e.g. the "Tabela Nutricional" group:
 * the text + a separate `+` icon + a border), clicking the icon, the border, or
 * the padding does nothing. This delegates clicks on the enclosing group to the
 * popup's own trigger, so the entire group is the hit area.
 *
 * Scope + guards: the click must land in a `.group-block-content` whose IMMEDIATE
 * popup-link is the one opened (so a parent group never hijacks a click meant for
 * a popup nested deeper). The native trigger, the open dialog, and any genuine
 * interactive control (real links, buttons, form fields) keep their own behavior.
 * Keyboard users still use the `<button>` (a real, focusable trigger) — this adds
 * a pointer-only enlargement, no extra tab stop. Logic/integration layer, vanilla
 * JS (FRONTEND-STACK §29).
 */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      var t = event.target;
      if (!t || !t.closest) return;

      // the native trigger + the open dialog (incl. its close button) self-handle
      if (t.closest('.popup-link__button')) return;
      if (t.closest('.popup-link__content')) return;
      // genuine interactive controls keep their own behavior (empty-href icons,
      // which render no <a>, are NOT excluded — they should open the popup)
      if (
        t.closest(
          'a[href]:not([href=""]), button, input, select, textarea, label, summary, [role="button"]'
        )
      ) {
        return;
      }

      var group = t.closest('.group-block-content');
      if (!group) return;

      // only a popup whose IMMEDIATE group is this one (not a deeper-nested popup)
      var comps = group.querySelectorAll('dialog-component.popup-link');
      for (var i = 0; i < comps.length; i++) {
        if (comps[i].closest('.group-block-content') === group) {
          var btn = comps[i].querySelector('.popup-link__button');
          if (btn) {
            btn.click();
            return;
          }
        }
      }
    },
    false
  );
})();
